import { Component, OnInit } from '@angular/core';
import { CampaignLeader } from '../badges-utils';

@Component({
  selector: 'app-campaign',
  templateUrl: './campaign.component.html',
  styleUrls: ['./campaign.component.scss'],
})
export class CampaignComponent implements OnInit {
  public campaignLeaders:Array<CampaignLeader> = [];
  public currenteCampaign:any;
  constructor() {
    this.campaignLeaders = JSON.parse(localStorage.getItem("campaign"));
    this.currenteCampaign = JSON.parse(localStorage.getItem("currenteCampaign"));
  }

  ngOnInit() {}

}
